module.exports = __webpack_public_path__ + "img/rank9.2c2368a3.png";